import type { ICellRendererParams } from 'ag-grid-community';
import { FindingSpecDto, FlowSpecDto } from '@ampsec/platform-client';
import React, { useMemo } from 'react';
import TargetFindingsCellContent from './TargetFindingsCellContent';
import {
  ConnectorProviderLookup,
  resolveTargetFindingDisplayItems,
} from './targetFindingDisplay.util';

type RefLike<T> = { current: T };

export type TargetFindingsCellRendererParams = ICellRendererParams<FlowSpecDto> & {
  connectorProviderMapRef?: RefLike<ConnectorProviderLookup[]>;
  findingSpecByIdRef?: RefLike<Record<string, FindingSpecDto>>;
  formatDisplayLabelRef?: RefLike<(value: string | null | undefined) => string>;
};

const TargetFindingsCellRenderer: React.FC<TargetFindingsCellRendererParams> = (params) => {
  const connectorProviderMap = params.connectorProviderMapRef?.current ?? [];
  const findingSpecById = params.findingSpecByIdRef?.current ?? {};
  const formatDisplayLabel = params.formatDisplayLabelRef?.current ?? ((value: string | null | undefined) => value ?? '');

  const items = useMemo(
    () =>
      resolveTargetFindingDisplayItems(params.data, {
        connectorProviderMap,
        findingSpecById,
        formatDisplayLabel,
      }),
    [connectorProviderMap, findingSpecById, formatDisplayLabel, params.data],
  );

  return <TargetFindingsCellContent items={items} />;
};

export default TargetFindingsCellRenderer;
